var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import React from 'react';
import { FormControlLabel, formControlLabelClasses, Switch as MuiSwitch, switchClasses, styled } from '@mui/material';
var CustomSwitch = styled(MuiSwitch)(function (_a) {
    var _b, _c, _d;
    var theme = _a.theme, size = _a.size;
    return __assign(__assign(__assign({}, (size === 'small' && {
        width: 30,
        height: 16,
    })), (size === 'medium' && {
        width: 36,
        height: 22,
    })), (_b = { padding: 0 }, _b["& .".concat(switchClasses.switchBase)] = (_c = {
            padding: 0,
            margin: 1,
            transitionDuration: '300ms'
        },
        _c["&.".concat(switchClasses.checked)] = (_d = {
                transform: 'translateX(14px)',
                color: '#fff'
            },
            _d["& + .".concat(switchClasses.track)] = {
                backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
                opacity: 1,
                border: 0,
            },
            _d['&.Mui-disabled + .MuiSwitch-track'] = {
                opacity: 0.5,
            },
            _d),
        _c['&.Mui-focusVisible .MuiSwitch-thumb'] = {
            color: '#33cf4d',
            border: '6px solid #fff',
        },
        _c['&.Mui-disabled .MuiSwitch-thumb'] = {
            color: theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[600],
        },
        _c['&.Mui-disabled + .MuiSwitch-track'] = {
            opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
        },
        _c), _b['& .MuiSwitch-thumb'] = __assign(__assign({ boxSizing: 'border-box' }, (size === 'small' && {
        width: 14,
        height: 14,
    })), (size === 'medium' && {
        width: 20,
        height: 20,
    })), _b['& .MuiSwitch-track'] = {
        borderRadius: 26 / 2,
        backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    }, _b));
});
var ControlLabel = styled(FormControlLabel)((_a = {
        margin: 0
    },
    _a["& .".concat(formControlLabelClasses.label)] = {
        fontSize: 14,
        marginLeft: 8,
    },
    _a));
var Switch = React.forwardRef(function (props, ref) {
    var children = props.children, label = props.label, sx = props.sx, labelPlacement = props.labelPlacement, SwitchProps = __rest(props, ["children", "label", "sx", "labelPlacement"]);
    return (React.createElement(ControlLabel, { sx: sx, control: React.createElement(CustomSwitch, __assign({}, SwitchProps)), label: label, labelPlacement: labelPlacement }));
});
Switch.defaultProps = {
    size: "medium",
    labelPlacement: 'end',
};
export default Switch;
